import React, { FC } from 'react';
import { BmisProvider } from '@packages/contexts/bmis';
import { Route, Routes } from 'react-router-dom';
import { bmisRoutes } from './bmis-routes';

export const BmisRouter: FC = () => {
    return (
        <BmisProvider>
            <Routes>
                {bmisRoutes.map((route) =>
                    route.index ? (
                        <Route key="index" index element={route.element} />
                    ) : (
                        <Route key={route.path} path={route.path} element={route.element} />
                    )
                )}
            </Routes>
        </BmisProvider>
    );
};
